export const CREATE_MODE = 'create'
export const EDIT_MODE = 'edit'

export const FOLDER_TYPE = 'folder'
export const SUB_FOLDER_TYPE = 'sub-folder'
